import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Table } from "react-bootstrap";
import { UserManagementActions } from "../../redux";
import BasicPagination from "../../../pagination/BasicPagination";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { deleteUserAsync } from "../../redux";
import StateChart from "./StateChart";
import {
  getUserStates,
  updateJuryAdminWithdrawStrikeLevel,
  sendTokenHistoryAsync,
} from "../../redux/userManagementApi";

import { Web3Context } from "../../../../../web3/contexts/web3Context";
import { poolMethods } from "../../../../../web3/functions/factory";
import Web3 from "web3";
import moment from "moment";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { CircularProgress } from "@material-ui/core";
import AddToken from "./AddToken";
import ReferrerHistoryModal from "./ReferrerHistoryModal";
import axios from "axios";

const UserManagementTable = ({ onUserDetailsClick }) => {
  const [DeleteModal, setDeleteModal] = useState(false);
  const deleteClose = () => setDeleteModal(false);
  const deleteShow = () => setDeleteModal(true);

  const [selectedID, setSelectedID] = useState();

  const [stateModel, setStateModel] = useState(false);
  const stateClose = () => setStateModel(false);
  const stateShow = () => setStateModel(true);

  const [WithdrawModal, setWithdrawModal] = useState(false);
  const WithdrawClose = () => setWithdrawModal(false);
  const WithdrawShow = () => setWithdrawModal(true);

  const [withdrawWalletAdd, setWithdrawWalletAdd] = useState("");
  const [userData, setUserData] = useState("");
  const [withdrawalProcess, setWithdrawalProcess] = useState(false);

  const [sendTokenModal, setSendTokenModal] = useState(false);
  const [userWalletAdd, setUserWalletAdd] = useState("");
  const [sendTokenUserId, setSendTokenUserId] = useState("");
  const sendTokenClose = () => setSendTokenModal(false);
  const sendTokenShow = () => setSendTokenModal(true);

  // Add Token modal state
  const [showAddToken, setShowAddToken] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showReferrerHistory, setShowReferrerHistory] = useState(false);
  const [selectedUserForHistory, setSelectedUserForHistory] = useState(null);

  // Login Activity modal state
  const [showLoginActivity, setShowLoginActivity] = useState(false);
  const [loginActivityLoading, setLoginActivityLoading] = useState(false);
  const [loginActivity, setLoginActivity] = useState([]);
  const [loginActivityUser, setLoginActivityUser] = useState({ userName: "" });

  const openLoginActivity = async (user) => {
    try {
      setShowLoginActivity(true);
      setLoginActivityLoading(true);
      setLoginActivity([]);
      setLoginActivityUser(user || {});
      const adminBaseURL = process.env.REACT_APP_BASE_URL;
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/user/getUserProfile`,
        headers: { "Content-Type": "application/json" },
        data: { user_id: user?._id },
      });
      if (data?.statusCode === 200) {
        const act = data?.data?.user?.loginActivity || [];
        // Sort by date desc if available
        act.sort((a, b) => (b?.date || 0) - (a?.date || 0));
        setLoginActivity(act);
      }
    } catch (e) {
      setLoginActivity([]);
    } finally {
      setLoginActivityLoading(false);
    }
  };

  const closeLoginActivity = () => {
    setShowLoginActivity(false);
    setLoginActivity([]);
    setLoginActivityUser({ userName: "" });
  };

  //show withdraw model and save withdraw details
  const onWithdrawClick = (userData) => {
    setWithdrawWalletAdd(userData.walletAddress);
    setUserData(userData);
    WithdrawShow();
  };

  //call withdraw contract
  const onWithdraw = async () => {
    //call contract for forward admin withdrawal
    dispatch(
      poolMethods.forwardAdminWithdrawal(
        getInstance,
        networkDetails.address,
        withdrawWalletAdd,
        setWithdrawalProcess
      )
    );
    setWithdrawWalletAdd("");
    WithdrawClose();
  };

  //show send token model and save bet details
  const onSendTokenClick = (userData) => {
    setUserWalletAdd(userData.walletAddress);
    setSendTokenUserId(userData._id);
    sendTokenShow();
  };

  // Handle Add Token button click
  const onAddTokenClick = (userData) => {
    setSelectedUser(userData);
    setShowAddToken(true);
  };

  const onReferrerHistoryClick = (userData) => {
    setSelectedUserForHistory(userData);
    setShowReferrerHistory(true);
  };

  //call send token amount contract
  const onSendToken = async (tokenAmount) => {
    //call contract for sent token amount to user
    dispatch(
      poolMethods.sendTokenAmountToUser(
        getDbethInstance,
        networkDetails.address,
        userWalletAdd,
        tokenAmount,
        {
          userWalletAdd: userWalletAdd,
          tokenAmount: tokenAmount,
          user_id: sendTokenUserId,
        }
      )
    );
    setUserWalletAdd("");
    sendTokenClose();
  };

  //call api after withdraw contract
  useEffect(() => {
    if (withdrawalProcess) {
      //call update jury admin withdraw strike level
      dispatch(
        updateJuryAdminWithdrawStrikeLevel(
          userData._id,
          userData.juryStrikeLevel
        )
      );
      setWithdrawalProcess(false);
      setUserData("");
    }
  }, [withdrawalProcess]);

  const [stateUsername, setStateUsername] = useState({
    username: "",
    categories: [],
    subcategories: [],
  });

  const dispatch = useDispatch();

  const {
    isLoading,
    userList,
    userStats,
    skip,
    limit,
    dir,
    searchBy,
  } = useSelector((state) => state.userManagement, shallowEqual);

  const onDeleteClick = (id) => {
    setSelectedID(id);
    deleteShow();
  };

  //call delte user api
  const onDeactiveClick = () => {
    dispatch(deleteUserAsync(selectedID._id));
    setSelectedID({});
    deleteClose();
  };

  //show user state details
  const onStatesClick = (username, categories, subcategories) => {
    setStateUsername({ username, categories, subcategories });
    stateShow();
    // dispatch(getUserStates(userId));
  };

  const onActivateClick = (userLists) => {
    dispatch(deleteUserAsync(userLists._id));
  };

  // on page change
  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(UserManagementActions.setUserBatchNumber(count));
  };

  //for sort details
  const handleSort = (column, dir) => {
    dispatch(UserManagementActions.setSort({ column, dir }));
  };

  const { networkDetails, handleConnect } = useContext(Web3Context);
  const [getInstance, setInstance] = useState();
  const [getDbethInstance, setDbethInstance] = useState();

  useEffect(() => {
    //console.log({networkDetails})
    (async () => {
      const instance = await poolMethods.getInstanceAdmin(networkDetails.web3);
      // console.log({ instance })
      if (instance) {
        setInstance(instance);
      }

      const dbethInstance = await poolMethods.getInstanceDbethToken(
        networkDetails.web3
      );
      // console.log({ dbethInstance })
      if (dbethInstance) {
        setDbethInstance(dbethInstance);
      }
    })();
  }, [networkDetails.web3]);

  //formik validation schema
  const sendTokenAmountSchema = Yup.object().shape({
    tokenAmount: Yup.number()
      .moreThan(0, "token amount must be greater than 0")
      .typeError("Must be a number")
      .integer("Must be integer")
      .required("Please enter token amount"),
  });

  return (
    <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
      <div className="tblmrgn mt-0">
        <div className="mt-5">
          <div>
            <Table
              hover
              responsive
              id="myTable"
              className="mb-0 default_table with_hoverbtn mrpdng_tbl"
            >
              <thead>
                <tr>
                  <th>Sr.no</th>
                  <th
                    onClick={() =>
                      handleSort(
                        "userName",
                        dir === "" || dir === "dsc" ? "asc" : "dsc"
                      )
                    }
                  >
                    User Name{" "}
                    {dir !== "" && searchBy === "userName" && (
                      <span className="svg-icon svg-icon-sm svg-icon-primary ml-1">
                        {dir === "dsc" ? (
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Navigation/Down-2.svg"
                            )}
                          />
                        ) : (
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Navigation/Up-2.svg"
                            )}
                          />
                        )}
                      </span>
                    )}
                  </th>
                  <th>Mobile Number</th>
                  <th>Email</th>
                  <th>Country</th>
                  <th>Total Tokens</th>
                  <th>Withdrawable Tokens</th>
                  <th>Non Withdrawable Tokens</th>
                  <th>Active P2P challenges</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {userList.users && userList.users.length ? (
                  userList.users.map((userLists, index) => {
                    return (
                      <tr key={index.toString()}>
                        <td>
                          <span className="f-w-500">
                            {skip * limit + (index + 1)}
                          </span>
                        </td>
                        <td>
                          <span className="f-w-500">
                            {userLists.userName ? userLists.userName : "-"}
                          </span>
                        </td>
                        <td>
                          {userLists.mobile_number
                            ? userLists.mobile_number
                            : "-"}
                        </td>
                        <td>{userLists.email ? userLists.email : "-"}</td>
                        <td>{userLists.country ? userLists.country : "-"}</td>
                        <td>
                          {userLists.total_token ? userLists.total_token : "-"}
                        </td>
                        <td>
                          {userLists.withdrawable_token
                            ? userLists.withdrawable_token
                            : "-"}
                        </td>
                        <td>
                          {userLists.non_withdrawable_token
                            ? userLists.non_withdrawable_token
                            : "-"}
                        </td>
                        <td>{userLists.activeBets}</td>
                        <td>
                          <span
                            className={`pmnt_btn label label-lg label-light-success label-inline`}
                          >
                            {userLists.isActive === true
                              ? "Active"
                              : "Inavtive"}
                          </span>
                        </td>
                        <td style={{width: "140px",minWidth: "140px"}}>
                          <a
                            title="Edit"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                            onClick={() => onUserDetailsClick(userLists)}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Write.svg"
                                )}
                              />
                            </span>
                          </a>
                          <a
                            title="Transaction History"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                            href={`/token-transaction?username=${userLists?.userName}`}
                            target="_blank"
                            
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Clipboard-list.svg"
                                )}
                              />
                            </span>
                          </a>
                          <a
                            title="Bet History"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                            href={`/bet-management?username=${userLists?.userName}`}
                            target="_blank"
                            style={{marginTop: "5px"}}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Spam.svg"
                                )}
                              />
                            </span>
                          </a>
                          <a
                            title="Add Token"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                            onClick={() => onAddTokenClick(userLists)}
                            style={{marginTop: "5px"}}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Shopping/Wallet.svg"
                                )}
                              />
                            </span>
                          </a>
                          <a
                            title="View Referrer History"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                            onClick={() => onReferrerHistoryClick(userLists)}
                            style={{marginTop: "5px"}}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                src={toAbsoluteUrl(
                                 "/media/svg/icons/custom/eye.svg"
                                )}
                              />
                            </span>
                          </a>
                          <a
                            title="Login Activity"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm"
                            onClick={() => openLoginActivity(userLists)}
                            style={{marginTop: "5px"}}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Devices/Display1.svg"
                                )}
                              />
                            </span>
                          </a>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={9} className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
                {isLoading && (
                  <tr>
                    <td colSpan={9} className="text-center p-0 border-0">
                      <div className="basic-verification-loader text-center">
                        <CircularProgress />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="row d-flex align-items-center mr-5 ml-5 mt-4 btm-pagination">
            <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-left">
              Displaying {skip * limit + 1} - {skip * limit + limit} of{" "}
              {userList.countUsers} Records
            </div>
            <div className="col-md-8 text-left mb-5 aspgntn">
              <BasicPagination
                totalRecords={userList.countUsers}
                limit={limit}
                batch={skip + 1}
                onBatchChange={onPageChange}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={stateModel}
        onHide={() => setStateModel(false)}
        centered
        className="def_modal delete_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fn_s_18 color_blk f-w-700">
            {stateUsername.username}'s Challenges Stats
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              <Table>
                <thead className="text-white">
                  <tr>
                    <th> Top Categories </th>
                  </tr>
                </thead>
                <tbody>
                  {stateUsername.categories &&
                    stateUsername.categories.map((cat, index) => (
                      <tr key={index} className="mt-5">
                        <td className="fn_s_18 f-w-500 text-white">
                          {cat.name}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>

              <Table>
                <thead className="text-white">
                  <tr>
                    <th> Top SubCategories </th>
                  </tr>
                </thead>
                <tbody>
                  {stateUsername.subcategories &&
                    stateUsername.subcategories.map((subCat, index) => (
                      <tr key={index} className="mt-5">
                        <td className="fn_s_18 f-w-500 text-white">
                          {subCat.name}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={DeleteModal}
        onHide={stateClose}
        centered
        className="def_modal delete_modal"
      >
        <Modal.Header>
          <Modal.Title className="fn_s_18 color_blk f-w-700">Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form def_form frmwtpddng">
            <p className="fn_s_18 f-w-400 text-center mb-10">
              Are you sure want to delete?
            </p>
            <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
              <div className="form-group mr-5 mb-1 mt-2">
                <button
                  className="btn_new btn-sm"
                  type="button"
                  onClick={stateClose}
                >
                  Close
                </button>
              </div>
              <div className="form-group mr-5 mb-1 mt-2">
                <button
                  className="btn_new btn-sm"
                  type="button"
                  onClick={onDeactiveClick}
                >
                  Yes, Deactivate
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal
        show={WithdrawModal}
        onHide={WithdrawClose}
        centered
        className="def_modal delete_modal"
      >
        <Modal.Header>
          <Modal.Title className="fn_s_18 color_blk f-w-700">Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form def_form frmwtpddng">
            <p className="fn_s_18 f-w-400 text-center mb-10">
              Stack Token will be transferd to admin wallet if you proceed ?
            </p>
            <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
              <div className="form-group mr-5 mb-1 mt-2">
                <button
                  className="btn_new btn-sm"
                  type="button"
                  onClick={WithdrawClose}
                >
                  Close
                </button>
              </div>
              <div className="form-group mr-5 mb-1 mt-2">
                <button
                  className="btn_new btn-sm"
                  type="button"
                  onClick={onWithdraw}
                >
                  Yes
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal
        show={sendTokenModal}
        onHide={sendTokenClose}
        centered
        className="def_modal delete_modal"
      >
        <Modal.Header>
          <Modal.Title className="fn_s_18 color_blk f-w-700">
            Token Amount
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={{
              tokenAmount: "",
            }}
            validationSchema={sendTokenAmountSchema}
            onSubmit={(values) => {
              onSendToken(values.tokenAmount);
            }}
          >
            {({
              values,
              errors,
              touched,
              isSubmitting,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldTouched,
              getFieldProps,
            }) => (
              <Form
                onSubmit={handleSubmit}
                className="form def_form frmwtpddng mt-n10"
              >
                <div className="form-group">
                  <input
                    placeholder="Enter Token Amount"
                    type="text"
                    name="tokenAmount"
                    className={
                      errors.tokenAmount && touched.tokenAmount
                        ? "form-control re_inputRouded is-invalid border-less-input"
                        : "form-control re_inputRouded border-less-input"
                    }
                    autoComplete="off"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.tokenAmount}
                  />
                  {touched.tokenAmount && errors.tokenAmount ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{errors.tokenAmount}</div>
                    </div>
                  ) : null}
                </div>
                <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
                  <div className="form-group mr-5 mb-1 mt-2">
                    <button
                      className="btn_new btn-sm"
                      type="button"
                      onClick={sendTokenClose}
                    >
                      Close
                    </button>
                  </div>
                  <div className="form-group mr-5 mb-1 mt-2">
                    <button className="btn_new btn-sm" type="submit">
                      Submit
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      {/* Add Token Modal */}
      <AddToken
        showAddToken={showAddToken}
        setShowAddToken={setShowAddToken}
        selectedUser={selectedUser}
      />
      <ReferrerHistoryModal
        show={showReferrerHistory}
        onHide={() => setShowReferrerHistory(false)}
        selectedUser={selectedUserForHistory}
      />

      {/* Login Activity Modal */}
      <Modal
        show={showLoginActivity}
        onHide={closeLoginActivity}
        centered
        className="def_modal delete_modal"
        size="xl"
      >
        <Modal.Header
          style={{
            background:
              "linear-gradient(90deg, rgba(26,26,26,1) 0%, rgba(48,48,48,1) 50%, rgba(26,26,26,1) 100%)",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
          }}
          closeButton
        >
          <Modal.Title className="fn_s_18 color_blk f-w-700" style={{ width: "100%" }}>
            <div className="d-flex align-items-center justify-content-between w-100">
              <span>
                Login Activity -{" "}
                {[
                  loginActivityUser?.userName,
                  loginActivityUser?.fullName,
                  loginActivityUser?.firstName &&
                    loginActivityUser?.lastName &&
                    `${loginActivityUser.firstName} ${loginActivityUser.lastName}`,
                  loginActivityUser?.email,
                  loginActivityUser?.mobile_number,
                  loginActivityUser?._id,
                ]
                  .filter(Boolean)
                  .map((val) => (typeof val === "string" ? val.trim() : val))
                  .find((val) => val && val !== "-") || "User"}
              </span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loginActivityLoading ? (
            <div className="text-center"><CircularProgress /></div>
          ) : (
            <div style={{ maxHeight: 520, overflow: "auto", paddingRight: 6, color: "#fff" }}>
              <Table responsive className="mb-0 default_table with_hoverbtn mrpdng_tbl">
                <thead style={{ position: "sticky", top: 0, zIndex: 1, background: "rgba(0,0,0,0.6)", color: "#fff" }}>
                  <tr>
                    <th style={{ borderTop: 0 }}>#</th>
                     <th style={{ borderTop: 0 }}>Date</th>
                    <th style={{ borderTop: 0 }}>Device</th>
                    <th style={{ borderTop: 0 }}>IP</th>
                    <th style={{ borderTop: 0 }}>Country</th>

                  </tr>
                </thead>
                <tbody style={{background: "rgba(0,0,0,0.6)", color: "#FFF" }}>
                  {loginActivity && loginActivity.length ? (
                    loginActivity
                      .filter((a) => {
                        const dev = (a?.device || "").toString().toLowerCase();
                        const ip = (a?.ipaddress || "").toString().toLowerCase();
                        return !(dev === "unknown" && ip === "unknown");
                      })
                      .sort((a, b) => {
                        // Sort by date descending, items without date go to the end
                        if (!a?.date && !b?.date) return 0;
                        if (!a?.date) return 1;
                        if (!b?.date) return -1;
                        // Convert Unix timestamp (seconds) to milliseconds if needed
                        const dateA = typeof a.date === 'number' && a.date < 9999999999 
                          ? a.date * 1000 
                          : moment(a.date).valueOf();
                        const dateB = typeof b.date === 'number' && b.date < 9999999999 
                          ? b.date * 1000 
                          : moment(b.date).valueOf();
                        return dateB - dateA; // Descending order
                      })
                      .map((a, idx) => {
                        // Format date: check if it's a Unix timestamp in seconds
                        let formattedDate = "-";
                        if (a?.date) {
                          try {
                            // If date is a number and looks like Unix timestamp in seconds (< 13 digits)
                            if (typeof a.date === 'number' && a.date < 9999999999) {
                              formattedDate = moment(a.date * 1000).format("MMM Do YYYY, h:mm a");
                            } else {
                              formattedDate = moment(a.date).format("MMM Do YYYY, h:mm a");
                            }
                          } catch (e) {
                            formattedDate = "-";
                          }
                        }
                        return (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                            <td>{formattedDate}</td>
                          <td>{a?.device || "-"}</td>
                          <td>{a?.ipaddress || "-"}</td>
                          <td>{a?.country || "-"}</td>
                        </tr>
                        );
                      })
                  ) : (
                    <tr>
                      <td colSpan={11} className="text-center">No Records</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UserManagementTable;
